/**
 * Vue mixin for dialog components to enable dialog closing on browser's back button clicked
 *
 * @link https://github.com/barryong/vue-dialog-mixin
 * @author Barry Ong
 */

import Vue from "vue";
import store from "@/store";

// dialogStore module
const dialogStoreAlpha = {
  namespaced: true,
  state: () => ({ dialogsAlpha: {} }),
  mutations: {
    SHOW_DIALOG_ALPHA(state, dialogAlpha) {
      Vue.set(state.dialogsAlpha, dialogAlpha, true)
    },
    HIDE_DIALOG_ALPHA(state, dialogAlpha) {
      if (state.dialogsAlpha[dialogAlpha]) Vue.set(state.dialogsAlpha, dialogAlpha, false)
    },
    DELETE_DIALOG_ALPHA(state, dialogAlpha) {
      Vue.delete(state.dialogsAlpha, dialogAlpha)
    },    
  },
};
const dialogStoreBeta = {
  namespaced: true,
  state: () => ({ dialogsBeta: {} }),
  mutations: {
    SHOW_DIALOG_BETA(state, dialogBeta) {
      Vue.set(state.dialogsBeta, dialogBeta, true)
    },
    HIDE_DIALOG_BETA(state, dialogBeta) {
      if (state.dialogsBeta[dialogBeta]) Vue.set(state.dialogsBeta, dialogBeta, false)
    },
    DELETE_DIALOG_BETA(state, dialogBeta) {
      Vue.delete(state.dialogsBeta, dialogBeta)
    },    
  },
};
const dialogStoreGamma = {
  namespaced: true,
  state: () => ({ dialogsGamma: {} }),
  mutations: {
    SHOW_DIALOG_GAMMA(state, dialogGamma) {
      Vue.set(state.dialogsGamma, dialogGamma, true)
    },
    HIDE_DIALOG_GAMMA(state, dialogGamma) {
      if (state.dialogsGamma[dialogGamma]) Vue.set(state.dialogsGamma, dialogGamma, false)
    },
    DELETE_DIALOG_GAMMA(state, dialogGamma) {
      Vue.delete(state.dialogsGamma, dialogGamma)
    },    
  },
};
const dialogStoreDelta = {
  namespaced: true,
  state: () => ({ dialogsDelta: {} }),
  mutations: {
    SHOW_DIALOG_DELTA(state, dialogDelta) {
      Vue.set(state.dialogsDelta, dialogDelta, true)
    },
    HIDE_DIALOG_DELTA(state, dialogDelta) {
      if (state.dialogsDelta[dialogDelta]) Vue.set(state.dialogsDelta, dialogDelta, false)
    },
    DELETE_DIALOG_DELTA(state, dialogDelta) {
      Vue.delete(state.dialogsDelta, dialogDelta)
    },    
  },
};
const dialogStoreIota = {
  namespaced: true,
  state: () => ({ dialogsIota: {} }),
  mutations: {
    SHOW_DIALOG_IOTA(state, dialogIota) {
      Vue.set(state.dialogsIota, dialogIota, true)
    },
    HIDE_DIALOG_IOTA(state, dialogIota) {
      if (state.dialogsIota[dialogIota]) Vue.set(state.dialogsIota, dialogIota, false)
    },
    DELETE_DIALOG_IOTA(state, dialogIota) {
      Vue.delete(state.dialogsIota, dialogIota)
    },    
  },
};
const dialogStoreTau = {
  namespaced: true,
  state: () => ({ dialogsTau: {} }),
  mutations: {
    SHOW_DIALOG_TAU(state, dialogTau) {
      Vue.set(state.dialogsTau, dialogTau, true)
    },
    HIDE_DIALOG_TAU(state, dialogTau) {
      if (state.dialogsTau[dialogTau]) Vue.set(state.dialogsTau, dialogTau, false)
    },
    DELETE_DIALOG_TAU(state, dialogTau) {
      Vue.delete(state.dialogsTau, dialogTau)
    },
  },
};
const dialogStoreOmega = {
  namespaced: true,
  state: () => ({ dialogsOmega: {} }),
  mutations: {
    SHOW_DIALOG_OMEGA(state, dialogOmega) {
      Vue.set(state.dialogsOmega, dialogOmega, true)
    },
    HIDE_DIALOG_OMEGA(state, dialogOmega) {
      if (state.dialogsOmega[dialogOmega]) Vue.set(state.dialogsOmega, dialogOmega, false)
    },
    DELETE_DIALOG_OMEGA(state, dialogOmega) {
      Vue.delete(state.dialogsOmega, dialogOmega)
    },    
  },
};
const dialogStoreKappa = {
  namespaced: true,
  state: () => ({ dialogsKappa: {} }),
  mutations: {
    SHOW_DIALOG_KAPPA(state, dialogKappa) {
      Vue.set(state.dialogsKappa, dialogKappa, true)
    },
    HIDE_DIALOG_KAPPA(state, dialogKappa) {
      if (state.dialogsKappa[dialogKappa]) Vue.set(state.dialogsKappa, dialogKappa, false)
    },
    DELETE_DIALOG_KAPPA(state, dialogKappa) {
      Vue.delete(state.dialogsKappa, dialogKappa)
    }
  },
};
const dialogStoreLambda = {
  namespaced: true,
  state: () => ({ dialogsLambda: {} }),
  mutations: {
    SHOW_DIALOG_LAMBDA(state, dialogLambda) {
      Vue.set(state.dialogsLambda, dialogLambda, true)
    },
    HIDE_DIALOG_LAMBDA(state, dialogLambda) {
      if (state.dialogsLambda[dialogLambda]) Vue.set(state.dialogsLambda, dialogLambda, false)
    },
    DELETE_DIALOG_LAMBDA(state, dialogLambda) {
      Vue.delete(state.dialogsLambda, dialogLambda)
    }
  },
};
const dialogStoreMu = {
  namespaced: true,
  state: () => ({ dialogsMu: {} }),
  mutations: {
    SHOW_DIALOG_MU(state, dialogMu) {
      Vue.set(state.dialogsMu, dialogMu, true)
    },
    HIDE_DIALOG_MU(state, dialogMu) {
      if (state.dialogsMu[dialogMu]) Vue.set(state.dialogsMu, dialogMu, false)
    },
    DELETE_DIALOG_MU(state, dialogMu) {
      Vue.delete(state.dialogsMu, dialogMu)
    }
  },
};
const dialogStoreNu = {
  namespaced: true,
  state: () => ({ dialogsNu: {} }),
  mutations: {
    SHOW_DIALOG_NU(state, dialogNu) {
      Vue.set(state.dialogsNu, dialogNu, true)
    },
    HIDE_DIALOG_NU(state, dialogNu) {
      if (state.dialogsNu[dialogNu]) Vue.set(state.dialogsNu, dialogNu, false)
    },
    DELETE_DIALOG_NU(state, dialogNu) {
      Vue.delete(state.dialogsNu, dialogNu)
    }
  },
};
const dialogStoreXi = {
  namespaced: true,
  state: () => ({ dialogsXi: {} }),
  mutations: {
    SHOW_DIALOG_XI(state, dialogXi) {
      Vue.set(state.dialogsXi, dialogXi, true)
    },
    HIDE_DIALOG_XI(state, dialogXi) {
      if (state.dialogsXi[dialogXi]) Vue.set(state.dialogsXi, dialogXi, false)
    },
    DELETE_DIALOG_XI(state, dialogXi) {
      Vue.delete(state.dialogsXi, dialogXi)
    }
  },
};
const dialogStorePi = {
  namespaced: true,
  state: () => ({ dialogsPi: {} }),
  mutations: {
    SHOW_DIALOG_PI(state, dialogPi) {
      Vue.set(state.dialogsPi, dialogPi, true)
    },
    HIDE_DIALOG_PI(state, dialogPi) {
      if (state.dialogsPi[dialogPi]) Vue.set(state.dialogsPi, dialogPi, false)
    },
    DELETE_DIALOG_PI(state, dialogPi) {
      Vue.delete(state.dialogsPi, dialogPi)
    }
  },
};

const dialogStoreRho = {
  namespaced: true,
  state: () => ({ dialogsRho: {} }),
  mutations: {
    SHOW_DIALOG_RHO(state, dialogRho) {
      Vue.set(state.dialogsRho, dialogRho, true)
    },
    HIDE_DIALOG_RHO(state, dialogRho) {
      if (state.dialogsRho[dialogRho]) Vue.set(state.dialogsRho, dialogRho, false)
    },
    DELETE_DIALOG_RHO(state, dialogRho) {
      Vue.delete(state.dialogsRho, dialogRho)
    }
  },
};
const dialogStoreSigma= {
  namespaced: true,
  state: () => ({ dialogsSigma: {} }),
  mutations: {
    SHOW_DIALOG_SIGMA(state, dialogSigma) {
      Vue.set(state.dialogsSigma, dialogSigma, true)
    },
    HIDE_DIALOG_SIGMA(state, dialogSigma) {
      if (state.dialogsSigma[dialogSigma]) Vue.set(state.dialogsSigma, dialogSigma, false)
    },
    DELETE_DIALOG_SIGMA(state, dialogSigma) {
      Vue.delete(state.dialogsSigma, dialogSigma)
    },
  },
};


if (!store.hasModule("dialogAlpha")) store.registerModule("dialogAlpha", dialogStoreAlpha)
if (!store.hasModule("dialogBeta")) store.registerModule("dialogBeta", dialogStoreBeta)
if (!store.hasModule("dialogDelta")) store.registerModule("dialogDelta", dialogStoreDelta)
if (!store.hasModule("dialogGamma")) store.registerModule("dialogGamma", dialogStoreGamma)
if (!store.hasModule("dialogIota")) store.registerModule("dialogIota", dialogStoreIota)

if (!store.hasModule("dialogKappa")) store.registerModule("dialogKappa", dialogStoreKappa)
if (!store.hasModule("dialogLambda")) store.registerModule("dialogLambda", dialogStoreLambda)
if (!store.hasModule("dialogMu")) store.registerModule("dialogMu", dialogStoreMu)
if (!store.hasModule("dialogNu")) store.registerModule("dialogNu", dialogStoreNu)
if (!store.hasModule("dialogXi")) store.registerModule("dialogXi", dialogStoreXi)
if (!store.hasModule("dialogPi")) store.registerModule("dialogPi", dialogStorePi)
if (!store.hasModule("dialogRho")) store.registerModule("dialogRho", dialogStoreRho)
if (!store.hasModule("dialogSigma")) store.registerModule("dialogSigma", dialogStoreSigma)
if(!store.hasModule("dialogTau")) store.registerModule("dialogTau", dialogStoreTau)
if(!store.hasModule("dialogOmega")) store.registerModule("dialogOmega", dialogStoreOmega)



// window.onpopstate
const onpopstate = function (e) {
  if (e.state && e.state.hasDialogAlpha) {
    store.commit("dialogAlpha/HIDE_DIALOG_ALPHA", e.state.dialogAlpha)
  }
  if (e.state && e.state.hasDialogBeta) {
    store.commit("dialogBeta/HIDE_DIALOG_BETA", e.state.dialogBeta)
  }
  if (e.state && e.state.hasDialogDelta) {
    store.commit("dialogDelta/HIDE_DIALOG_DELTA", e.state.dialogDelta)
  }
  if (e.state && e.state.hasDialogGamma) {
    store.commit("dialogGamma/HIDE_DIALOG_GAMMA", e.state.dialogGamma)
  }
  if (e.state && e.state.hasDialogIota) {
    store.commit("dialogIota/HIDE_DIALOG_IOTA", e.state.dialogIota)
  }

  if (e.state && e.state.hasDialogKappa) {
    store.commit("dialogKappa/HIDE_DIALOG_KAPPA", e.state.dialogKappa)
  }
  if (e.state && e.state.hasDialogLambda) {
    store.commit("dialogLambda/HIDE_DIALOG_LAMBDA", e.state.dialogLambda)
  }
  if (e.state && e.state.hasDialogMu) {
    store.commit("dialogMu/HIDE_DIALOG_MU", e.state.dialogMu)
  }
  if (e.state && e.state.hasDialogNu) {
    store.commit("dialogNu/HIDE_DIALOG_NU", e.state.dialogNu)
  }
  if (e.state && e.state.hasDialogXi) {
    store.commit("dialogXi/HIDE_DIALOG_XI", e.state.dialogXi)
  }
  if (e.state && e.state.hasDialogPi) {
    store.commit("dialogPi/HIDE_DIALOG_PI", e.state.dialogPi)
  }
  if (e.state && e.state.hasDialogRho) {
    store.commit("dialogRho/HIDE_DIALOG_RHO", e.state.dialogRho)
  }
  if (e.state && e.state.hasDialogSigma) {
    store.commit("dialogSigma/HIDE_DIALOG_SIGMA", e.state.dialogSigma)
  }
  if (e.state && e.state.hasDialogTau) {
    store.commit("dialogTau/HIDE_DIALOG_TAU", e.state.dialogTau)
  }
  if (e.state && e.state.hasDialogOmega) {
    store.commit("dialogOmega/HIDE_DIALOG_OMEGA", e.state.dialogOmega)
  }

};
if (window.onpopstate !== onpopstate) window.onpopstate = onpopstate

export default {
  data() {
    return {          
      dialogNameAlpha: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameBeta: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameDelta: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameGamma: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameIota: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameKappa: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameLambda: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameMu: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameNu: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameXi: "_" + Math.random().toString(36).substr(2, 9),
      dialogNamePi: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameRho: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameSigma: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameTau: "_" + Math.random().toString(36).substr(2, 9),
      dialogNameOmega: "_" + Math.random().toString(36).substr(2, 9),
                  
      dialogAlpha: false,
      dialogBeta: false,
      dialogDelta: false,
      dialogGamma: false,
      dialogIota: false,
      dialogKappa: false,
      dialogLambda: false,
      dialogMu: false,
      dialogNu: false,
      dialogXi: false,
      dialogPi: false,
      dialogRho: false,
      dialogSigma: false,
      dialogTau: false,
      dialogOmega: false,


    };
  },
  methods: {
    
    showDialogAlpha() {
      this.$store.commit("dialogAlpha/SHOW_DIALOG_ALPHA", this.dialogNameAlpha)
    },
    showDialogBeta() {
      this.$store.commit("dialogBeta/SHOW_DIALOG_BETA", this.dialogNameBeta)
    } ,
    showDialogDelta() {
      this.$store.commit("dialogDelta/SHOW_DIALOG_DELTA", this.dialogNameDelta)
    } ,
    showDialogGamma() {
      this.$store.commit("dialogGamma/SHOW_DIALOG_GAMMA", this.dialogNameGamma)
    } ,
    showDialogIota() {
      this.$store.commit("dialogIota/SHOW_DIALOG_IOTA", this.dialogNameIota)
    } ,
    showDialogKappa() {
      this.$store.commit("dialogKappa/SHOW_DIALOG_KAPPA", this.dialogNameKappa)
    } ,
    showDialogLambda() {
      this.$store.commit("dialogLambda/SHOW_DIALOG_LAMBDA", this.dialogNameLambda)
    } ,
    showDialogMu() {
      this.$store.commit("dialogMu/SHOW_DIALOG_MU", this.dialogNameMu)
    } ,
    showDialogNu() {
      this.$store.commit("dialogNu/SHOW_DIALOG_NU", this.dialogNameNu)
    } ,
    showDialogXi() {
      this.$store.commit("dialogXi/SHOW_DIALOG_XI", this.dialogNameXi)
    } ,
    showDialogPi() {
      this.$store.commit("dialogPi/SHOW_DIALOG_PI", this.dialogNamePi)
    } ,
    showDialogRho() {
      this.$store.commit("dialogRho/SHOW_DIALOG_RHO", this.dialogNameRho)
    } ,
    showDialogSigma() { 
      this.$store.commit("dialogSigma/SHOW_DIALOG_SIGMA", this.dialogNameSigma)
    } ,
    showDialogTau() {
      this.$store.commit("dialogTau/SHOW_DIALOG_TAU", this.dialogNameTau)
    } ,
    showDialogOmega() {
      this.$store.commit("dialogOmega/SHOW_DIALOG_OMEGA", this.dialogNameOmega)
    } ,
    

    
   
    closeDialogAlpha() {
      this.$store.commit("dialogAlpha/HIDE_DIALOG_ALPHA", this.dialogNameAlpha)
    },
    closeDialogBeta() {
      this.$store.commit("dialogBeta/HIDE_DIALOG_BETA", this.dialogNameBeta)
    } ,
    closeDialogDelta() {
      this.$store.commit("dialogDelta/HIDE_DIALOG_DELTA", this.dialogNameDelta)
    } ,
    closeDialogGamma() {
      this.$store.commit("dialogGamma/HIDE_DIALOG_GAMMA", this.dialogNameGamma)
    } ,
    closeDialogIota() {
      this.$store.commit("dialogIota/HIDE_DIALOG_IOTA", this.dialogNameIota)
    },
    closeDialogKappa() {
      this.$store.commit("dialogKappa/HIDE_DIALOG_KAPPA", this.dialogNameKappa)
    } ,
    closeDialogLambda() {
      this.$store.commit("dialogLambda/HIDE_DIALOG_LAMBDA", this.dialogNameLambda)
    } ,
    closeDialogMu() {
      this.$store.commit("dialogMu/HIDE_DIALOG_MU", this.dialogNameMu)
    } ,
    closeDialogNu() {
      this.$store.commit("dialogNu/HIDE_DIALOG_NU", this.dialogNameNu)
    } ,
    closeDialogXi() {
      this.$store.commit("dialogXi/HIDE_DIALOG_XI", this.dialogNameXi)
    } ,
    closeDialogPi() {
      this.$store.commit("dialogPi/HIDE_DIALOG_PI", this.dialogNamePi)
    } ,
    closeDialogRho() {
      this.$store.commit("dialogRho/HIDE_DIALOG_RHO", this.dialogNameRho)
    } ,
    closeDialogSigma() {
      this.$store.commit("dialogSigma/HIDE_DIALOG_SIGMA", this.dialogNameSigma)
    } ,
    closeDialogTau() {
      this.$store.commit("dialogTau/HIDE_DIALOG_TAU", this.dialogNameTau)
    } ,
    closeDialogOmega() {
      this.$store.commit("dialogOmega/HIDE_DIALOG_OMEGA", this.dialogNameOmega)
    }

  },
  computed: {
    
    dialogStateAlpha() {
      return this.$store.state.dialogAlpha.dialogsAlpha[this.dialogNameAlpha]
    },
    dialogStateBeta() {
      return this.$store.state.dialogBeta.dialogsBeta[this.dialogNameBeta]
    } ,
    dialogStateDelta() {
      return this.$store.state.dialogDelta.dialogsDelta[this.dialogNameDelta]
    } ,
    dialogStateGamma() {
      return this.$store.state.dialogGamma.dialogsGamma[this.dialogNameGamma]
    } ,
    dialogStateIota() {
      return this.$store.state.dialogIota.dialogsIota[this.dialogNameIota]
    } ,
    dialogStateKappa() {
      return this.$store.state.dialogKappa.dialogsKappa[this.dialogNameKappa]
    } ,
    dialogStateLambda() {
      return this.$store.state.dialogLambda.dialogsLambda[this.dialogNameLambda]
    } ,
    dialogStateMu() {
      return this.$store.state.dialogMu.dialogsMu[this.dialogNameMu]
    } ,
    dialogStateNu() {
      return this.$store.state.dialogNu.dialogsNu[this.dialogNameNu]
    } , 
    dialogStateXi() {
      return this.$store.state.dialogXi.dialogsXi[this.dialogNameXi]
    } ,
    dialogStatePi() {
      return this.$store.state.dialogPi.dialogsPi[this.dialogNamePi]
    } , 
    dialogStateRho() {
      return this.$store.state.dialogRho.dialogsRho[this.dialogNameRho]
    } ,
    dialogStateSigma() {
      return this.$store.state.dialogSigma.dialogsSigma[this.dialogNameSigma]
    } ,
    dialogStateTau() {
      return this.$store.state.dialogTau.dialogsTau[this.dialogNameTau]
    } ,
    dialogStateOmega() {
      return this.$store.state.dialogOmega.dialogsOmega[this.dialogNameOmega]
    }
  },
  watch: {
    
    dialogStateAlpha(newValueAlpha) {
      this.dialogAlpha = newValueAlpha ? true : false
    },
    dialogStateBeta(newValueBeta) {
      this.dialogBeta = newValueBeta ? true : false
    } ,
    dialogStateDelta(newValueDelta) {
      this.dialogDelta = newValueDelta ? true : false
    } ,
    dialogStateGamma(newValueGamma) {
      this.dialogGamma = newValueGamma ? true : false
    } ,
    dialogStateIota(newValueIota) {
      this.dialogIota = newValueIota ? true : false
    },    
    dialogStateKappa(newValueKappa) {
      this.dialogKappa = newValueKappa ? true : false
    } ,
    dialogStateLambda(newValueLambda) {
      this.dialogLambda = newValueLambda ? true : false
    } ,
    dialogStateMu(newValueMu) {
      this.dialogMu = newValueMu ? true : false
    } ,
    dialogStateNu(newValueNu) {
      this.dialogNu = newValueNu ? true : false
    } ,
    dialogStateXi(newValueXi) {
      this.dialogXi = newValueXi ? true : false
    } ,
    dialogStatePi(newValuePi) {
      this.dialogPi = newValuePi ? true : false
    } ,
    dialogStateRho(newValueRho) {
      this.dialogRho = newValueRho ? true : false
    } ,
    dialogStateSigma(newValueSigma) {
      this.dialogSigma = newValueSigma ? true : false
    } ,
    dialogStateTau(newValueTau) {
      this.dialogTau = newValueTau ? true : false
    } ,
    dialogStateOmega(newValueOmega) {
      this.dialogOmega = newValueOmega ? true : false
    },


    
    dialogAlpha(newValueAlpha) {
      if (newValueAlpha === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogAlpha = true
        hs.dialogAlpha = this.dialogNameAlpha
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogAlpha();
      } else if (newValueAlpha == false) {
        this.$store.commit("dialogAlpha/DELETE_DIALOG_ALPHA", this.dialogNameAlpha)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogAlpha" in hs && hs.dialogAlpha === this.dialogNameAlpha))
            window.history.go(-1)
          hs.hasDialogAlpha = false
          hs.dialogAlpha = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogBeta(newValueBeta) {
      if (newValueBeta === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogBeta = true
        hs.dialogBeta = this.dialogNameBeta
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogBeta();
      } else if (newValueBeta == false) {
        this.$store.commit("dialogBeta/DELETE_DIALOG_BETA", this.dialogNameBeta)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogBeta" in hs && hs.dialogBeta === this.dialogNameBeta))
            window.history.go(-1)
          hs.hasDialogBeta = false
          hs.dialogBeta = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    } ,
    dialogDelta(newValueDelta) {
      if (newValueDelta === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogDelta = true
        hs.dialogDelta = this.dialogNameDelta
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogDelta();
      } else if (newValueDelta == false) {
        this.$store.commit("dialogDelta/DELETE_DIALOG_DELTA", this.dialogNameDelta)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogDelta" in hs && hs.dialogDelta === this.dialogNameDelta))
            window.history.go(-1)
          hs.hasDialogDelta = false
          hs.dialogDelta = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogGamma(newValueGamma) {
      if (newValueGamma === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogGamma = true
        hs.dialogGamma = this.dialogNameGamma
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogGamma();
      } else if (newValueGamma == false) {
        this.$store.commit("dialogGamma/DELETE_DIALOG_GAMMA", this.dialogNameGamma)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogGamma" in hs && hs.dialogGamma === this.dialogNameGamma))
            window.history.go(-1)
          hs.hasDialogGamma = false
          hs.dialogGamma = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogIota(newValueIota) {
      if (newValueIota === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogIota = true
        hs.dialogIota = this.dialogNameIota
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogIota();
      } else if (newValueIota == false) {
        this.$store.commit("dialogIota/DELETE_DIALOG_IOTA", this.dialogNameIota)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogIota" in hs && hs.dialogIota === this.dialogNameIota))
            window.history.go(-1)
          hs.hasDialogIota = false
          hs.dialogIota = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogKappa(newValueKappa) {
      if (newValueKappa === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogKappa = true
        hs.dialogKappa = this.dialogNameKappa
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogKappa();
      } else if (newValueKappa == false) {
        this.$store.commit("dialogKappa/DELETE_DIALOG_KAPPA", this.dialogNameKappa)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogKappa" in hs && hs.dialogKappa === this.dialogNameKappa))
            window.history.go(-1)
          hs.hasDialogKappa = false
          hs.dialogKappa = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogLambda(newValueLambda) {
      if (newValueLambda === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogLambda = true
        hs.dialogLambda = this.dialogNameLambda
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogLambda();
      } else if (newValueLambda == false) {
        this.$store.commit("dialogLambda/DELETE_DIALOG_LAMBDA", this.dialogNameLambda)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogLambda" in hs && hs.dialogLambda === this.dialogNameLambda))
            window.history.go(-1)
          hs.hasDialogLambda = false
          hs.dialogLambda = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogMu(newValueMu) {
      if (newValueMu === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogMu = true
        hs.dialogMu = this.dialogNameMu
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogMu();
      } else if (newValueMu == false) {
        this.$store.commit("dialogMu/DELETE_DIALOG_MU", this.dialogNameMu)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogMu" in hs && hs.dialogMu === this.dialogNameMu))
            window.history.go(-1)
          hs.hasDialogMu = false
          hs.dialogMu = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogNu(newValueNu) {
      if (newValueNu === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogNu = true
        hs.dialogNu = this.dialogNameNu
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogNu();
      } else if (newValueNu == false) {
        this.$store.commit("dialogNu/DELETE_DIALOG_NU", this.dialogNameNu)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogNu" in hs && hs.dialogNu === this.dialogNameNu))
            window.history.go(-1)
          hs.hasDialogNu = false
          hs.dialogNu = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogXi(newValueXi) {
      if (newValueXi === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogXi = true
        hs.dialogXi = this.dialogNameXi
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogXi();
      } else if (newValueXi == false) {
        this.$store.commit("dialogXi/DELETE_DIALOG_XI", this.dialogNameXi)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogXi" in hs && hs.dialogXi === this.dialogNameXi))

            window.history.go(-1) 
          hs.hasDialogXi = false
          hs.dialogXi = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogPi(newValuePi) {
      if (newValuePi === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogPi = true
        hs.dialogPi = this.dialogNamePi
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogPi();
      } else if (newValuePi == false) {
        this.$store.commit("dialogPi/DELETE_DIALOG_PI", this.dialogNamePi)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogPi" in hs && hs.dialogPi === this.dialogNamePi))
            window.history.go(-1)
          hs.hasDialogPi = false
          hs.dialogPi = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogRho(newValueRho) {
      if (newValueRho === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogRho = true
        hs.dialogRho = this.dialogNameRho
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogRho();
      } else if (newValueRho == false) {
        this.$store.commit("dialogRho/DELETE_DIALOG_RHO", this.dialogNameRho)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogRho" in hs && hs.dialogRho === this.dialogNameRho))
            window.history.go(-1)
          hs.hasDialogRho = false
          hs.dialogRho = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogSigma(newValueSigma) {
      if (newValueSigma === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogSigma = true
        hs.dialogSigma = this.dialogNameSigma
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogSigma();
      } else if (newValueSigma == false) {
        this.$store.commit("dialogSigma/DELETE_DIALOG_SIGMA", this.dialogNameSigma)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogSigma" in hs && hs.dialogSigma === this.dialogNameSigma))
            window.history.go(-1)
          hs.hasDialogSigma = false
          hs.dialogSigma = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },
    dialogTau(newValueTau) {
      if (newValueTau === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogTau = true
        hs.dialogTau = this.dialogNameTau
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogTau();
      } else if (newValueTau == false) {
        this.$store.commit("dialogTau/DELETE_DIALOG_TAU", this.dialogNameTau)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogTau" in hs && hs.dialogTau === this.dialogNameTau))
            window.history.go(-1)
          hs.hasDialogTau = false
          hs.dialogTau = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    },   
    dialogOmega(newValueOmega) {
      if (newValueOmega === true) {
        let hs = window.history.state ? window.history.state : {}
        hs.hasDialogOmega = true
        hs.dialogOmega = this.dialogNameOmega
        window.history.replaceState(hs, "")
        window.history.pushState(null, "")
        this.showDialogOmega();
      } else if (newValueOmega == false) {
        this.$store.commit("dialogOmega/DELETE_DIALOG_OMEGA", this.dialogNameOmega)
        setTimeout(() => {
          this.$emit("close")
          let hs = window.history.state ? window.history.state : {}
          if (!("hasDialogOmega" in hs && hs.dialogOmega === this.dialogNameOmega))
            window.history.go(-1)
          hs.hasDialogOmega = false
          hs.dialogOmega = ""
          window.history.replaceState(hs, "")
        }, 300); // 20200814 - fix animation not working when the modal closed
      }
    }





    

  },
};
